import {AuthShell} from '@/components/layouts/AuthLayout';
import {LoginPage} from './LoginPage';
import {authApi} from '@/api/auth';
import {useCallback, useEffect, useRef, useState} from 'react';

export function LogoutPage() {
    const [error, setError] = useState(false);
    const started = useRef(false);

    const signOut = useCallback(async () => {
        setError(false);
        try {
            await authApi.signOut();
            window.location.replace('/login');
        } catch {
            setError(true);
        }
    }, []);

    useEffect(() => {
        if (!started.current) {
            started.current = true;
            void signOut();
        }
    }, [signOut]);

    return <AuthShell>
        {error ? <main>
            <p role="alert">We could not sign you out. Please try again.</p>
            <button type="button" onClick={() => void signOut()}>Try again</button>
        </main> : <div ref={element => element?.setAttribute('inert', '')} aria-busy="true">
            <LoginPage />
        </div>}
    </AuthShell>;
}
